import { isNullOrUndefined } from 'util';
import { Injectable, Inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  constructor() {}

  getToken() {
    return localStorage.getItem('token');
  }

  /**
   * Comprobación de que el token existe
   */
  comprobandoToken() {
    const token_string = localStorage.getItem('token');
    if (!isNullOrUndefined(token_string)) {
      return true;
    } else {
      return false;
    }
  }

  // Poniendo token en localstorage
  setToken(token): void {
    localStorage.setItem('token', token);
  }
}
